/**
 * normalizeInstallationSearch coerces the `?installation_id=…` search param to a
 * string for the onboarding route.
 *
 * The router parses a numeric-looking value (e.g. `?installation_id=147020643`)
 * as a JS number, and a GitHub installation id is always numeric. The onboarding
 * API's `installationId` is contractually a string, so a bare number reaching the
 * PATCH body makes the backend reject the whole request with
 * 400 "cannot unmarshal number into string". Stringifying here guarantees the id
 * is sent as the contract requires, regardless of how the router typed it.
 */
export function normalizeInstallationSearch(search: Record<string, unknown>): {
  installation_id?: string;
} {
  return {
    installation_id:
      search.installation_id != null
        ? String(search.installation_id)
        : undefined,
  };
}
